"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.website = void 0;
var base_1 = require("./base");
exports.website = {
    base: base_1.websiteURL,
    impressum: base_1.websiteURL + "/impressum",
    privacyPolicy: base_1.websiteURL + "/privacy-policy",
    termsAndConditions: base_1.websiteURL + "/terms-and-conditions",
    support: base_1.websiteURL + "/support",
    press: base_1.websiteURL + "/press",
    business: base_1.websiteURL + "/business",
};
